module.exports = __webpack_public_path__ + "img/ls.ls1656b1d.svg";